import React, { createContext, useState, useContext, useEffect } from 'react';

const ClinicContext = createContext();

export const useClinic = () => {
  const context = useContext(ClinicContext);
  if (!context) {
    throw new Error('useClinic must be used within a ClinicProvider');
  }
  return context;
};

export const ClinicProvider = ({ children }) => {
  const [clinicId, setClinicId] = useState(null);
  const [clinicData, setClinicData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try to get clinic from multiple sources
    const detectClinic = () => {
      // 1. Check URL parameter (e.g., ?clinic=rosas_medical_center)
      const urlParams = new URLSearchParams(window.location.search);
      const urlClinic = urlParams.get('clinic');
      
      if (urlClinic) {
        setClinicId(urlClinic);
        localStorage.setItem('clinic_id', urlClinic);
        setLoading(false);
        return;
      }

      // 2. Check localStorage
      const savedClinic = localStorage.getItem('clinic_id');
      if (savedClinic) {
        setClinicId(savedClinic);
        setLoading(false);
        return;
      }

      // 3. Check subdomain (for future production use)
      const host = window.location.hostname;
      const parts = host.split('.');
      
      // If subdomain exists and it's not 'www' or 'app'
      if (parts.length >= 3 && !['www', 'app', 'api'].includes(parts[0])) {
        const subdomain = parts[0];
        // We would need to fetch clinic data from backend based on subdomain
        // For now, we'll set it as potential clinic_id
        console.log('Detected subdomain:', subdomain);
      }

      setLoading(false);
    };

    detectClinic();
  }, []);

  const selectClinic = (id, data = null) => {
    setClinicId(id);
    setClinicData(data);
    localStorage.setItem('clinic_id', id);
    if (data) {
      localStorage.setItem('clinic_data', JSON.stringify(data));
    }
  };

  const clearClinic = () => {
    setClinicId(null);
    setClinicData(null);
    localStorage.removeItem('clinic_id');
    localStorage.removeItem('clinic_data');
  };

  return (
    <ClinicContext.Provider
      value={{
        clinicId,
        clinicData,
        loading,
        selectClinic,
        clearClinic,
      }}
    >
      {children}
    </ClinicContext.Provider>
  );
};
